export default __webpack_public_path__ + "static/media/export.4de5ef36.png";